import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { toast } from 'sonner';

const useAssignDiscountCategory = () => {
  const { mutateAsync, isPending } = useMutation('assignDiscountCategory', {
    onSuccess: (res) => {
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useAssignDiscountCategory;
